<template>
  <!-- 红字增值税传统发票信息表界面 -->
  <div>
    <pop-modal
      :visible="visible"
      :isDrag="true"
      title="红字增值税专用发票信息表填开"
      :width="1280"
      :height="100"
      transform="0.8"
      @cancel="handelCancel"
    >
      <div class="wrap">
        <div class="main">
          <div class="main-top">
            <div></div>
            <div>
              <a-button type="primary" ghost>导入</a-button>
              <a-button type="primary" @click="printSave" :loading="printLoading">打印</a-button>
            </div>
          </div>
          <div class="main-cont" ref="invoice">
            <div class="cont-invoice">
              <div class="invoice-header"></div>
              <div class="invoice-no">
                <div>
                  <div class="date">
                    <span>{{ taxBillDate | filterDate }}</span>
                  </div>
                  <div class="applyer">{{ buyerName }}</div>
                  <div class="number">{{ tabPipeNum }}</div>
                </div>
              </div>
              <div class="invoice-buyer">
                <div class="left">
                  <div class="enterpriseName">
                    <input type="text" v-model="enterpriseName" /> <a-icon type="plus-square" class="addImg" />
                  </div>
                  <div class="enterpriseTaxPayerId">
                    <input type="text" v-model="enterpriseTaxPayerId" /><a-icon type="plus-square" class="addImg" />
                  </div>
                </div>
                <div class="right">
                  <span class="buyerName">{{ buyerName }}</span>
                  <span class="buyerTaxPayerId">{{ buyerTaxPayerId }}</span>
                </div>
              </div>
              <div class="invoice-table">
                <div class="table-header tab">
                  <div style="flex: 0.3">
                    <input type="checkbox" name="" id="" v-model="allChecked" @change="checkAll()" />
                  </div>
                  <div style="flex: 3">货物或应税劳务、服务名称</div>
                  <div style="flex: 1">规格型号</div>
                  <div style="flex: 1">单位</div>
                  <div style="flex: 1">数量</div>
                  <div style="flex: 1.5">单价({{ price == 'taxfree' ? '不含税' : '含税' }})</div>
                  <div style="flex: 1.5">金额({{ price == 'taxfree' ? '不含税' : '含税' }})</div>
                  <div style="flex: 1">税率</div>
                  <div style="flex: 1">税额</div>
                </div>
                <div class="table-content tab red" v-for="(data, i) in list" :key="i">
                  <div style="flex: 0.3; text-align: center">
                    <input type="checkbox" name="" id="" v-model="data.checked" @change="checkChange(data, i)" />
                  </div>
                  <div style="flex: 3">
                    <div class="relative">
                      <input type="text" :value="comGoodsName(data.goodsName,data.goodsCodeName)" :readonly="!onlyQd" />
                      <a-icon type="plus-square" class="addImg" />
                    </div>
                  </div>
                  <div style="flex: 1">
                    <input type="text" v-model="data.goodsGauge" readonly />
                  </div>
                  <div style="flex: 1">
                    <input type="text" v-model="data.goodsUnits" readonly />
                  </div>
                  <div style="flex: 1">
                    <input type="number" v-model="data.goodsAmounts" @change="goodsAmountsChange(i)" readonly />
                  </div>
                  <div style="flex: 1.5">
                    <input type="number" v-model="data.goodsUnitPrice" @change="goodsUnitPriceChange(i)" readonly />
                  </div>
                  <div style="flex: 1.5">
                    <input
                      type="number"
                      v-model="data.goodsPriceAmounts"
                      @change="taxAmountPayablesChange(i)"
                      readonly
                    />
                  </div>
                  <div style="flex: 1">
                    <select
                      v-model="data.goodsTaxRates"
                      @change="rateChange(i)"
                      :disabled="data.goodsName && isDisOnly(data, i)"
                    >
                      <option value="0">不征税</option>
                      <option value="0.00">0%</option>
                      <option value="0.03">3%</option>
                      <option value="0.05">5%</option>
                      <option value="0.015">按减1.5%计算</option>
                      <option value="0.09">9%</option>
                      <option value="0.11">11%</option>
                      <option value="0.13">13%</option>
                      <option value="0.16">16%</option>
                      <option value="0.17">17%</option>
                    </select>
                  </div>
                  <div style="flex: 1"><input type="text" v-model="data.taxAmountPayables" readonly /></div>
                </div>
              </div>
              <div class="invoice-sum">
                <span style="position: absolute; left: 160px; top: 7px">￥{{ moneyAmount }}</span>
                <span style="position: absolute; left: 396px; top: 7px">￥{{ rateMoneyAmount }}</span>
              </div>
              <!-- <div class="invoice-taxsum">
                <span style="position: absolute; left: 356px; top: 469px">{{ moneyAndRate }}</span>
                <span style="position: absolute; left: 876px; top: 469px">{{ moneyAndRate }}</span>
              </div> -->
              <div class="invoice-saler">
                <div class="left">
                  <a-radio-group v-model="apply">
                    <a-radio value="0" style="display: block">
                      一、购买方申请
                      <a-radio-group v-model="deduction" disabled style="display: block; margin-left: 20%">
                        <span>对应蓝字增值税专用发票抵扣增值税销项税额情况</span>
                        <a-radio value="0" style="display: block"> 1、已抵扣 </a-radio>
                        <a-radio value="1"> 2、未抵扣</a-radio>
                      </a-radio-group>
                    </a-radio>
                    <a-radio value="1"> 二、销售方申请 </a-radio>
                  </a-radio-group>
                </div>
                <div class="right">
                  <div>对应蓝字专用发票密码区内打印的发票信息</div>
                  <div>{{ taxBillCode }}</div>
                  <div>{{ taxBillNo }}</div>
                  <div>增值税专用发票</div>
                </div>
              </div>
              <!-- <div class="invoice-footer">
                <div class="payee"><input type="text" v-model="enterprise.payee" /></div>
                <div class="review"><input type="text" v-model="enterprise.rechecker" /></div>
                <div class="billing">{{ enterprise.drawer }}</div>
              </div> -->
            </div>
            <div class="cont-op">
              <a-button type="primary" ghost @click="addList('fp')" v-if="type !== 'detail'">增行</a-button>
              <a-button type="primary" ghost @click="delList()" v-if="type !== 'detail'">减行</a-button>
              <a-button type="primary" ghost @click="insertList()" v-if="type !== 'detail'">插行</a-button>
              <a-button type="primary" ghost @click="priceChange()">含税</a-button>
            </div>
          </div>
        </div>
      </div>
    </pop-modal>
    <print ref="printModal" @printFp="printFpChange('N')" @cancelFPrintFp="printFpChange('Y')"></print>
  </div>
</template>

<script>
import Urls from '@/utils/globel.js'
import { parseParam, keepTwoDecimalFull } from '@/utils/util'
import { mapGetters, mapActions } from 'vuex'
// import ossService from '@/utils/oss.service'
// import { environment } from '@/utils/oss.env'
import Utils from '@/utils/oss.util'
import Print from '@/components/Print/print.vue'
export default {
  components: {
    Print,
  },
  data() {
    return {
      visible: false,
      selectedData: [],
      allChecked: false,
      detailId: '',
      onlyQd: false,
      detailedList: [],
      list: [],
      price: 'taxfree',
      moneyAmount: '',
      rateMoneyAmount: '',
      moneyAndRate: '',
      redInvoiceList: {}, // 红字发票信息
      invoiceData: {},
      enterpriseName: '',
      enterpriseTaxPayerId: '',
      taxBillDate: '',
      taxBillNo: '',
      taxBillCode: '',
      tabPipeNum: '',
      apply: '',
      deduction: '',
      buyerTaxPayerId: '',
      buyerName: '',
      type: '',
      printLoading: false,
    }
  },
  computed: {
    ...mapGetters('practice', ['TASK_DATA', 'ENTERPRISE', 'LOGIN_INFO']),
  },
  filters: {
    filterDate(v) {
      const dateArr = v.split('-')
      return v.length ? `${dateArr[0]}年${dateArr[1]}月${dateArr[2]}日` : ''
    },
  },
  methods: {
    async show(invoiceData, type) {
      this.type = type
      this.visible = true
      this.invoiceData = invoiceData
      this.getRedInvoice(invoiceData)
      this.apply = invoiceData.apply
      this.deduction = invoiceData.deduction
    },
    comGoodsName(name1,name2){
      let name = name2==undefined?'':'*' + name2
      return name1 + name
    },
    handelCancel() {
      this.visible = false
    },
    setParam(obj, cloneObj) {
      for (const key in cloneObj) {
        if (Object.hasOwnProperty.call(cloneObj, key)) {
          const element = cloneObj[key]
          obj[key] = element
        }
      }
    },
    // 获取红字发票信息
    async getRedInvoice(invoiceData) {
      this.initVoiceData()
      const params = parseParam({
        taxBillCode: invoiceData.taxBillCode == null ? '' : invoiceData.taxBillCode,
        taxBillNo: invoiceData.taxBillNo == null ? '' : invoiceData.taxBillNo,
        apply: invoiceData.apply == null ? '' : invoiceData.apply,
        deduction: invoiceData.deduction == null ? '' : invoiceData.deduction,
        taxClass: invoiceData.taxClass == null ? '' : invoiceData.taxClass,
      })
      const res = await this.$http.post(`${Urls.getRedInvoice}&${params}`)
      if (res.statusCode === '200') {
        this.redInvoiceList = res.data
        if (res.data != null && this.redInvoiceList.redTaxBList != null) {
          this.list = this.redInvoiceList.redTaxBList
          this.amountMoney()
        }
        this.enterpriseName = res.data.enterpriseName
        this.enterpriseTaxPayerId = res.data.enterpriseTaxPayerId
        this.taxBillDate = res.data.taxBillDate
        this.buyerName = res.data.buyerName
        this.buyerTaxPayerId = res.data.buyerTaxPayerId
        this.taxBillCode = res.data.taxBillCode
        this.taxBillNo = res.data.taxBillNo
        this.tabPipeNum = res.data.tabPipeNum
      }
    },
    // 获取红字发票信息详情
    async seeRedInvoiceDetail(invoiceId, type) {
      this.type = type
      this.visible = true
      const params = parseParam({ invoiceId: invoiceId })
      const res = await this.$http.post(`${Urls.seeRedInvoiceDetail}&${params}`)
      if (res.statusCode === '200') {
        this.redInvoiceList = res.data
        if (res.data != null && this.redInvoiceList.redTaxBList != null) {
          this.list = this.redInvoiceList.redTaxBList
          this.amountMoney()
        }
        this.enterpriseName = res.data.enterpriseName
        this.enterpriseTaxPayerId = res.data.enterpriseTaxPayerId
        this.buyerTaxPayerId = res.data.buyerTaxPayerId
        this.taxBillDate = res.data.taxBillDate
        this.buyerName = res.data.buyerName
        this.taxBillNo = res.data.taxBillNo
        this.tabPipeNum = res.data.tabPipeNum
        this.apply = res.data.apply
        this.deduction = res.data.deduction
      }
    },
    // 初始化发票数据
    initVoiceData() {
      this.list = []
      this.selectedData = []
      this.price = 'taxfree'
      this.moneyAmount = ''
      this.rateMoneyAmount = ''
      this.moneyAndRate = ''
    },
    // 多选
    checkAll() {
      if (this.allChecked) {
        this.list.forEach((data, i) => {
          data.checked = true
          this.selectedData.push(data)
        })
      } else {
        this.initSelected()
        this.list.forEach((v) => (v.checked = false))
      }
    },
    checkChange(data, i) {
      if (data.checked) {
        // data.checked = true
        this.selectedData.push(data)
      } else {
        // data.checked = false
        this.selectedData = this.selectedData.filter((v) => v.checked)
      }
      this.allChecked = this.selectedData.length === this.list.length
    },
    // 初始化全选
    initSelected() {
      this.selectedData = []
      this.allChecked = false
    },
    isDisOnly(data, i) {
      return data.isDiscount || (this.list[i + 1] && this.list[i + 1].isDiscount)
    },
    // 添加行
    addList(type) {
      if (type === 'fp') {
        if (this.list.length === 8) {
          return
        }
        if (this.onlyQd) {
          this.$message.warning({
            title: '警告',
            content: '请到清单里面进行操作!',
          })
          return
        }
        this.list.splice(this.list.length + 1, 0, this.initFP())
      } else {
        this.detailedList.splice(this.detailedList.length + 1, 0, this.initFP())
      }
    },
    // 删除行
    delList(type) {
      if (!this.selectedData.length) {
        this.$info({
          title: '提示',
          content: '请勾选要删除的商品行',
        })
        return
      }
      if (this.selectedData.every((v) => v.isDiscount)) {
        this.$info({
          title: '提示',
          content: '您将要删除的商品行为折扣行，删除此行将取消上行商品的折扣。您要继续吗？',
          onOk: () => {
            this.deleSelf(this.list)
            this.initSelected()
            this.amountMoney()
          },
          onCancel: () => false,
        })
        return
      }
      if (this.selectedData.some((v) => v.isDiscount)) {
        this.$info({
          title: '提示',
          content: '您将要删除的商品行有折扣行，删除此行也可能将删除折扣行。您要继续吗？',
          onOk: () => {
            this.deleSelf(this.list)
            this.initSelected()
            this.amountMoney()
          },
          onCancel: () => false,
        })
        return
      }
      this.deleSelf(this.list)
      this.initSelected()
      this.amountMoney()
    },
    deleSelf(arr) {
      arr.forEach((v, index) => {
        if (v.checked) {
          if (arr[index + 1] && arr[index + 1].isDiscount && arr[index + 1].isDiscount) arr[index + 1].checked = true
          arr.splice(index, 1)
          this.deleSelf(arr)
        }
      })
    },
    // 插入行
    insertList() {
      if (!this.selectedData.length) {
        this.$info({
          title: '提示',
          content: '请先选择要插入行的位置!',
        })
        return
      }
      this.insertSelf(this.list)
      this.initSelected()
      this.amountMoney()
    },
    insertSelf(arr) {
      arr.forEach((v, index) => {
        if (v.checked) {
          if (arr.length < 8) {
            arr.splice(index, 0, this.initFP())
          }
          v.checked = false
          this.insertSelf(arr)
        }
      })
    },
    // 是否含税切换
    priceChange() {
      const list = this.list
      if (list == null || list.length < 1) {
        this.$info({
          title: '提示',
          content: '数据为空!',
        })
        return
      }
      this.price = this.price === 'taxfree' ? 'unit' : 'taxfree'
      for (let i = 0; i < list.length; i++) {
        if (list[i].goodsTaxRates !== null || list[i].goodsTaxRates !== 0) {
          const num = (100 + list[i].goodsTaxRates * 100) / 100
          const s = list[i].goodsUnitPrice
          // 第一个计算式为不含税，第二个为含税
          // 如果列表为折扣列表，则不进行单价计算
          if (!list[i].isDiscount) {
            list[i].goodsUnitPrice =
              this.price === 'taxfree' ? Number((s * num).toFixed(4)) : Number((s / num).toFixed(4))
          }
          this.calcPriceAmounts(i)
        }
      }
      this.amountMoney()
    },
    // 初始化发票
    initFP(type) {
      const studentReportTaxBList = {
        goodsCodeId: '',
        goodsCodeName: '',
        goodsName: '',
        goodsGauge: '',
        goodsUnits: '',
        goodsAmounts: null,
        // 不含税单价
        goodsUnitPrice: null,
        // 含税单价
        unitprice: null,
        goodsPriceAmounts: null,
        unitmoney: null,
        goodsTaxRates: null,
        taxAmountPayables: null,
        hasTax: '',
        alias: '',
        checked: false, // 是否被选中
        isDiscount: type === 'discount', // 是否为折扣行
      }
      return studentReportTaxBList
    },
    /**
     * 数量变化
     * @param i
     * goodsAmounts 数量  goodsUnitPrice 单价  goodsPriceAmounts  金额  taxAmountPayables 税额   goodsTaxRates 税率
     */
    goodsAmountsChange(i) {
      const listItem = this.list[i]
      // 单价 和金额为空时 不做操作
      if (!listItem.goodsUnitPrice && !listItem.goodsPriceAmounts) return
      if (listItem.goodsUnitPrice == null && listItem.goodsPriceAmounts != null) {
        // 单价为空 金额不为空 计算单价
        this.calcUnitPrice(i)
      }
      this.calcPriceAmounts(i) // 计算金额
      this.rateChange(i)
      this.amountMoney()
    },
    /**
     * 单价变化
     * @param i
     * goodsAmounts 数量  goodsUnitPrice 单价  goodsPriceAmounts  金额  taxAmountPayables 税额   goodsTaxRates 税率
     */
    goodsUnitPriceChange(i) {
      const listItem = this.list[i]
      // 数量 和 金额 为空时 不做操作
      if (!listItem.goodsAmounts && !listItem.goodsPriceAmounts) return
      // 数量为空 金额不为空 计算数量
      if (listItem.goodsAmounts == null && listItem.goodsPriceAmounts != null) {
        this.calcAmounts(i) // 计算数量
      }
      this.calcPriceAmounts(i) // 计算金额
      this.rateChange(i)
      this.amountMoney()
    },
    /**
     * 金额改变
     * goodsAmounts 数量  goodsUnitPrice 单价  goodsPriceAmounts  金额  taxAmountPayables税额   goodsTaxRates 税率
     * @param i
     */
    taxAmountPayablesChange(i) {
      const listItem = this.list[i]
      // 数量 和单价为空时 不做操作
      if (!listItem.goodsAmounts && !listItem.goodsUnitPrice) return
      // 数量为空 单价不为空 计算数量
      if (listItem.goodsAmounts == null && listItem.goodsUnitPrice != null) {
        this.calcAmounts(i) // 计算数量
      }
      listItem.goodsPriceAmounts = Number(listItem.goodsPriceAmounts).toFixed(2) // 转换金额为小数点后两位
      this.calcUnitPrice(i) // 计算单价
      this.rateChange(i)
      this.amountMoney()
    },
    // 计算数量
    calcAmounts(i) {
      const listItem = this.list[i]
      listItem.goodsAmounts = keepTwoDecimalFull(listItem.goodsPriceAmounts / listItem.goodsUnitPrice) // 计算数量
    },
    // 计算单价
    calcUnitPrice(i) {
      const listItem = this.list[i]
      listItem.goodsUnitPrice = keepTwoDecimalFull(listItem.goodsPriceAmounts / listItem.goodsAmounts).toFixed(2) // 计算单价
    },
    // 计算金额
    calcPriceAmounts(i) {
      const listItem = this.list[i]
      const calcItem = listItem.isDiscount ? this.list[i - 1] : listItem
      listItem.goodsPriceAmounts = keepTwoDecimalFull(calcItem.goodsUnitPrice * calcItem.goodsAmounts).toFixed(2) // 计算金额
    },
    // 计算税额
    rateChange(i) {
      const listItem = this.list[i]
      const calcItem = listItem.isDiscount ? this.list[i - 1] : listItem
      if (this.price === 'taxfree') {
        listItem.taxAmountPayables = keepTwoDecimalFull(calcItem.goodsPriceAmounts * calcItem.goodsTaxRates).toFixed(2) // 税额 等于金额*税率
      } else {
        // 税额为含税时应该计算不含税金额的税率
        const num = (100 + calcItem.goodsTaxRates * 100) / 100
        const s = calcItem.goodsUnitPrice
        const goodsUnitPrice = keepTwoDecimalFull(s / num).toFixed(2)
        const goodsPriceAmounts = (Number(goodsUnitPrice) * listItem.goodsAmounts).toFixed(2)
        listItem.taxAmountPayables = (Number(goodsPriceAmounts) * calcItem.goodsTaxRates).toFixed(2)
      }
    },
    // 计算总额
    amountMoney() {
      this.moneyAmount = 0
      this.rateMoneyAmount = 0
      this.moneyAndRate = 0
      for (let i = 0; i < this.list.length; i++) {
        if (this.price === 'taxfree') {
          this.moneyAmount += Number(this.list[i].goodsPriceAmounts)
          this.rateMoneyAmount += Number(this.list[i].taxAmountPayables)
        } else {
          this.moneyAmount += Number(this.list[i].goodsPriceAmounts)
          this.rateMoneyAmount += Number(this.list[i].taxAmountPayables)
        }
      }
      if (this.price === 'taxfree') {
        this.moneyAndRate = Number((this.moneyAmount + this.rateMoneyAmount).toFixed(2))
      } else {
        this.moneyAndRate = Number(this.moneyAmount.toFixed(2))
      }
    },
    // 发票保存
    async printSave() {
      if (this.redDetail != null) {
        return
      }
      if (this.checkDate()) {
        this.$error({
          title: '提示',
          content: '参数错误',
        })
        return
      }
      if (this.goodsAmountsNumber()) {
        // 数量为正数
        this.$error({
          title: '提示',
          content: '红字发票数量不为正数!',
        })
        return
      }
      const taskData = Utils.getTaskDataRedFontByModType('7')
      if (taskData == null) {
        this.$error({
          title: '提示',
          content: '本次课程没有此业务!',
        })
        return
      }
      this.printLoading = true
      const params = parseParam({
        moduleId: taskData.id,
        data: JSON.stringify(this.redInvoiceList),
      })
      taskData.isFinish = 2
      taskData.status = 0
      const res = await this.$http.post(`${Urls.saveRedInvoice}&${params}`)
      if (res) {
        // 打印保存数据
        this.savaDataed = true // 以保存过数据
        await this.uploadTestByOSS({ result: res, isFinish: '2' })
        await this.getBusinessList()
        this.handelCancel()
        this.showPrint() // 显示打印框
        // this.uplodeOSS(res, taskData)
      }
      this.printLoading = false
    },
    // 显示弹框
    showPrint() {
      this.$refs.printModal.show()
    },
    // 关闭弹框
    closePrint() {
      this.$refs.printModal.close()
    },
    // 点击打印/不打印
    async printFpChange(type) {
      if (type === 'N') {
        this.$info({
          title: '提示',
          content: '不打印，但数据已经保存！',
        })
      } else if (type === 'Y') {
        this.$print(this.$refs.invoice)
      }
      this.closePrint()
    },
    /**
     * 判断数据是否合法
     */
    checkDate() {
      if (this.list == null || this.list.length < 1) {
        return true
      }
      for (let i = 0; i < this.list.length; i++) {
        if (
          !this.list[i].goodsName ||
          !this.list[i].goodsAmounts ||
          !this.list[i].goodsUnitPrice ||
          !this.list[i].goodCodeId ||
          !this.list[i].goodsUnits
        ) {
          return true
        }
      }
      return false
    },
    goodsAmountsNumber() {
      // 商品数量是否为正数 (红字发票数量不为正数)
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].goodsAmounts >= 0) {
          return true
        }
      }
      return false
    },
    /**
     * 上传做题记录到OSS
     * @param result
     * @param TaskDat
     */
    // uplodeOSS(result, taskData) {
    //   const uu = environment.dshDataUrl + this.LOGIN_INFO.testId + '.o'
    //   const data = this.TASK_DATA
    //   const detailId = result.detailId
    //   const moduleId = result.moduleId
    //   ossService.ossput(uu, data, moduleId, detailId)
    // },
    ...mapActions('practice', ['getTasksBySeq', 'getBusinessList', 'uploadTestByOSS']),
  },
}
</script>

<style lang="less" scoped>
.wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  color: #000;
}
.main {
  background-color: #e4e7fa;
  flex: 1;
  .main-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px;
    button {
      margin: 0 5px;
    }
  }
}
.main-cont {
  display: flex;
  flex: 1;
  justify-content: space-around;
  .cont-invoice {
    width: 1137px;
    height: 665px;
    background-image: url(~@/assets/credit-memo.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin: 5px;
    position: relative;
    .invoice-header {
      height: 78px;
      display: block;
      font-size: 29px;
      font-family: '宋体';
      font-weight: 700;
      border: none;
      color: #9d5426;
      position: relative;
      span {
        position: absolute;
        left: 444px;
        top: 38px;
      }
    }
    .invoice-no {
      margin-top: 8px;
      .applyer {
        position: absolute;
        left: 427px;
      }
      .number {
        // margin-left: 69px;
        position: absolute;
        left: 652px;
      }
      .date {
        display: inline-block;
        // margin-left: 503px;
        position: absolute;
        left: 156px;
      }
    }
    .invoice-buyer {
      margin-top: 40px;
      position: relative;
      input[type='text'] {
        border: 1px solid #a2ddfb;
        display: block;
      }
      .left {
        margin-left: 236px;
        display: inline-block;
        position: relative;
        height: 77px;
        .enterpriseName {
          position: absolute;
          top: 7px;
        }
        .enterpriseTaxPayerId {
          position: absolute;
          top: 46px;
        }
        input {
          width: 327px;
        }
      }
      .right {
        display: inline-block;
        margin-left: 300px;
        left: 734px;
        .buyerName {
          position: absolute;
          left: 737px;
          top: 9px;
        }
        .buyerTaxPayerId {
          position: absolute;
          left: 737px;
          top: 48px;
        }
      }
    }
    .invoice-table {
      width: 88.9%;
      margin-left: 5.6%;
      min-height: 241px;
      .tab {
        display: flex;
        height: 26.6px;
        > div {
          border: 1px solid #a2ddfb;
          box-sizing: border-box;
          width: 100%;
        }
      }
      .table-header {
        text-align: center;
        background-color: #cee3f4;
      }
      .table-content {
        input[type='text'],
        input[type='number'],
        select {
          width: 100%;
          height: 100%;
          border: none;
          background-color: transparent;
        }
      }
    }
    .invoice-sum {
      font-weight: 500;
      height: 28px;
      position: relative;
    }
    .invoice-taxsum {
      height: 36px;
      line-height: 36px;
      font-weight: 500;
    }
    .invoice-saler {
      display: flex;
      height: 158px;
      .left {
        margin-left: 114px;
        margin-top: 16px;
      }
      .right {
        margin-left: 260px;
        width: 380px;
        height: 95px;
        > div {
          height: 32px;
          line-height: 32px;
        }
      }
    }
    .invoice-footer {
      display: flex;
      align-items: center;
      margin-top: 3px;
      .payee {
        margin-left: 187px;
      }
      .review {
        margin-left: 87px;
      }
      .billing {
        margin-left: 48px;
      }
      input[type='text'] {
        border: 1px solid #a2ddfb;
      }
    }
  }
  .cont-op {
    display: flex;
    flex-direction: column;
    padding: 5px;
    justify-content: center;
    button {
      margin: 5px 0;
    }
  }
}
.discountWrap {
  padding: 5% 10%;
  color: #000;
  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    .left,
    .right {
      width: 45%;
      font-size: 16px;
    }
    .left {
      text-align: right;
    }
    .right {
      text-align: left;
    }
  }
}
.addImg {
  position: absolute;
  right: 3px;
  top: 2px;
  width: 18px;
}
.relative {
  position: relative;
}
</style>
<style lang="less">
.wrap {
  .main-top,
  .main-cont {
    .ant-btn-background-ghost {
      background-color: #fff !important;
    }
  }
}
</style>
